/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Ai_TitleInputs */

const en_directory_hubs_signals_ai_title = /** @type {(inputs: Directory_Hubs_Signals_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can an AI agent actually use this product?`)
};

const zh_directory_hubs_signals_ai_title = /** @type {(inputs: Directory_Hubs_Signals_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Agent 能不能真正用起来这个产品？`)
};

/**
* | output |
* | --- |
* | "Can an AI agent actually use this product?" |
*
* @param {Directory_Hubs_Signals_Ai_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_ai_title = /** @type {((inputs?: Directory_Hubs_Signals_Ai_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Ai_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_ai_title(inputs)
	return zh_directory_hubs_signals_ai_title(inputs)
});
export { directory_hubs_signals_ai_title as "directory.hubs.signals.ai.title" }